
import React , { Fragment, useState } from 'react'
import { Dialog, Popover, Tab, Transition, Listbox } from '@headlessui/react'
import Carousel from 'react-grid-carousel'

import {
  MenuIcon,
  XIcon,

} from '@heroicons/react/outline'
import UseDarkMode from './useDarkMode'
import useApiRequest from './useFetch'
import { CheckIcon, SelectorIcon } from '@heroicons/react/solid'
import cookies from 'js-cookie'
import { useTranslation } from 'react-i18next'


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function HeaderComponent() {

  const { data: safari } = useApiRequest(
    "https://resania.com/safari_api/"
  );
  const { data: kilimanjaro } = useApiRequest(
    "https://resania.com/kilimanjaro_api/"
  );


  const [colorTheme, setTheme] = UseDarkMode();
  const [open, setOpen] = useState(false)
  const { t } = useTranslation();

  const navigation = {
    categories: [
      {
        id: 'safari',
        name: 'Safari',
        featured: safari,
        sections: [
          {
            id: 'practical info',
            name: 'Practical Information',
            items: [
              { name: 'What should be on my Packing list ?', href: '/resania/resania-articles/safari-packing-list', icon: 'fa fa-suitcase fa-lg fa-fw' },
              { name: 'What to Expect on Safari', href: '/resania/resania-articles/what-to-expect-on-a-safari-in-tanzania', icon: 'fa fa-paw fa-lg fa-fw' },
              { name: 'Best Time To See Great Migration ?', href: '/resania/great-migration', icon: 'fa fa-binoculars fa-lg fa-fw' },
              { name: 'Best time for Safari ?', href: '/resania/resania-articles/best-time-for-safari-in-tanzania', icon: 'fa fa-calendar fa-lg fa-fw' },
              { name: 'Can i bring my Children ?', href: '/resania/resania-articles/age-restrictions-on-safari-in-tanzania', icon: 'fa fa-users fa-lg fa-fw' },
              { name: 'Browse All', href: '/resania/resania-articles', icon: 'fab fa-readme fa-lg fa-fw' },
            ],
          },
          {
            id: 'categories',
            name: 'Safari Category',
            items: [
              { name: 'Walking Safari', href: '/resania/daytrips/arusha' },
              { name: 'Private Camping Safari', href: '/resania/safari' },
              { name: 'Public Camping Safari', href: '/resania/safari' },
              { name: 'Day Trips', href: '/resania/daytrips' },
              { name: 'Family Friendly', href: '/resania/safari' },
              { name: 'See All', href: '/resania/safari' },

            ],
          },

        ],
      },
      {
        id: 'kilimanjaro',
        name: 'Climbing',
        featured: kilimanjaro,
        sections: [
          {
            id: 'clothing',
            name: 'Practical Information',
            items: [
              { name: 'How to get prepared for a climb?', href: '/resania/resania-articles/how-to-prepare-for-a-climb' , icon: 'fas fa-hiking fa-lg fa-fw' },
              { name: 'Which Kilimanajaro Route to choose', href: '/resania/resania-articles/which-kilimanjaro-climbing-route-to-choose' , icon: ' fas fa-map-marked-alt fa-lg fa-fw'},
              { name: 'What Climbing Gears do i need ?', href: '/resania/resania-articles/kilimanjaro-climbing-gears' , icon: 'fas fa-tshirt fa-lg fa-fw'},
              { name: 'Best Time For Climbing', href: '/resania/resania-articles/when-is-the-best-time-to-climb-kilimanjaro' , icon: 'fa fa-calendar fa-lg fa-fw'},
              { name: 'Good to know before climbing', href: '/resania/resania-articles/how-to-prepare-for-a-climb' , icon: ' far fa-newspaper fa-lg fa-fw fa'},
              { name: 'Browse All', href: '/resania/resania-articles' , icon: 'fab fa-readme fa-lg fa-fw '},
            ],
          },
          {
            id: 'climbing route',
            name: 'Climbing Routes',
            items: [
              { name: 'Rongia Route', href: '/resania/kilimanjaro/rongai' },
              { name: 'Marangu Route', href: '/resania/kilimanjaro/marangu' },
              { name: 'Lemosho Route', href: '/resania/kilimanjaro/lemosho' },
              { name: 'All Routes', href: '/resania/kilimanjaro' },

            ],
          },
        ],
      },
      {
        id: 'zanzibar',
        name: 'Zanzibar',
        featured: [
          {
            title: 'Private Island',
            slug: '',
            img_url: 'https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/thanda-island.webp',
            imageAlt: 'Visit Zanziba | Thanda private Island',
          },
          {
            title: 'Zanzibar Activites',
            slug: 'stone_town',
            img_url: 'https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/whaleshark-mafia.jpg',
            imageAlt: 'Activities in anzibar',
          }
        ],
        sections: [
          {
            id: 'practical info',
            name: 'Practical Info',
            items: [
              { name: 'Best Diving Spots', href: '/resania/resania-articles/list-of-diving-sites-in-tanzania', icon:'fas fa-water fa-lg fa-fw' },
              { name: 'How is the weather like in tanzania', href: '/#weather' , icon:'fas fa-sun fa-lg fa-fw'},
              { name: 'Best time for beach vacation', href: '/resania/resania-articles/best-time-for-beach-vacation' , icon:'fas fa-umbrella-beach fa-lg fa-fw'},
              { name: 'What should i pack for the beach vacation', href: '/resania/resania-articles/beach-life-in-tanzania-what-to-take' , icon:'fas fa-swimmer fa-lg fa-fw'},
              { name: 'Browse All', href: '/resania/resania-articles', icon:'fab fa-readme fa-lg fa-fw' },
            ],
          },
          {
            id: 'activities',
            name: 'Activities In Zanzibar',
            items: [
              { name: 'Spice Tour', href: '/resania/zanzibar/spice' },
              { name: 'Snorkelling', href: '/resania/zanzibar/snorkelling' },
              { name: 'Kite Surfing', href: '/resania/zanzibar/surfing' },
              { name: 'Check Out Stone Town', href: '/resania/zanzibar/stone_town' },
              { name: 'See All', href: '/resania/zanzibar' },


            ],
          },
        ],
      },
    ],
    pages: [
      { name: 'About Us', href: '/resania/about' },
      { name: 'Academy', href: '/resania/resania-academy' },
      { name: 'Contacts', href: '/resania/contactus' },

    ],
  }
  const language = [
    {
      code: '',
      name: 'English',
      country_code: 'gb',
      flag: 'https://img.icons8.com/external-justicon-flat-justicon/64/000000/external-uk-flag-countrys-flags-justicon-flat-justicon.png'
    },
    {
      code: 'se.',
      name: 'Svenska',
      country_code: 'se',
      flag: 'https://img.icons8.com/color/48/000000/sweden-circular.png'
    }
  ]
  const [selected, setSelected] = useState(language[0])
  const currentLanguageCode = cookies.get('i18next') || 'en'


  return (
    <div className='z-40 fixed top-0 w-full'>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="fixed inset-0 flex z-40 lg:hidden" onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
          >
            <div className="relative max-w-xl w-full shadow-xl pb-12 flex flex-col overflow-y-auto bg-gray-700 dark:bg-gray-900">
              <div className="px-4 pt-5 pb-2 flex">
                <button
                  type="button"
                  className="-m-2 p-2 rounded-md inline-flex items-center justify-center text-gray-100 dark:text-gray-200"
                  onClick={() => setOpen(false)}
                >
                  <span className="sr-only">Close menu</span>
                  <XIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>

              {/* Links */}
              <Tab.Group as="div" className="mt-2">
                <div className="border-b border-gray-100">
                  <Tab.List className="-mb-px flex px-4 space-x-8">
                    {navigation.categories.slice(0, 3).map((category) => (
                      <Tab
                        key={category.name}
                        className={({ selected }) =>
                          classNames(
                            selected ? 'text-color border-yellow-700 border-b-4' : 'text-gray-100 dark:text-gray-200 border-transparent',
                            'flex-1 whitespace-nowrap py-4 px-1 border-b-2 text-base font-medium'
                          )
                        }
                      >
                        {category.name}
                      </Tab>
                    ))}
                  </Tab.List>
                </div>
                <Tab.Panels as={Fragment}>
                  {navigation.categories.map((category) => (
                    <Tab.Panel key={category.name} className="pt-10 pb-8 px-4 space-y-10 text-gray-200">
                      <div className="grid grid-cols-1 gap-x-4">
                        <Carousel cols={1} rows={1} gap={2}>
                          {category.featured.slice(0, 8).map((item, index) => (
                            <Carousel.Item key={index}>
                              <div key={item.title} className="group relative text-base sm:text-md">
                                
                                  <div className="aspect-h-3 aspect-w-3 rounded-lg bg-gray-700 overflow-hidden group-hover:opacity-75">
                                    <img alt="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"title="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"
                                      src={item.img_url}
                                      className="object-center object-cover"
                                    />
                                  </div>
                              
                                <a href={`/resania/${category.id}/${item.slug}`} className="mt-6 block font-medium text-gray-100 dark:text-gray-lightest">
                                  <span className="absolute z-10 inset-0" aria-hidden="true" />
                                  <h3 className="mt-4 text-sm text-gray-100">{item.tour_days}</h3>
                                  <h3 className="mt-4 text-sm text-gray-100">{item.title}</h3>
                                </a>
                                {item.price ? (
                                  <p className="mt-1 text-lg font-medium text-gray-100">From ${item.price}</p>
                                ) : ''
                                }

                              </div>
                            </Carousel.Item>
                          ))}
                        </Carousel>
                      </div>
                      {category.sections.map((section) => (
                        <div key={section.name} className='border-gray-900 border-b-4'>
                          <p id={`${category.id}-${section.id}-heading-mobile`} className="font-medium text-gray-100">
                            {section.name}
                          </p>
                          <ul
                            aria-labelledby={`${category.id}-${section.id}-heading-mobile`}
                            className="mt-6 flex flex-col space-y-6 underline"
                          >
                            {section.items.map((item) => (
                              <li key={item.name} className="flow-root">
                                <a href={item.href} className="-m-2 p-2 block text-gray-200 dark:text-color">
                                  <i className={item.icon} aria-hidden="true" style={{ marginRight: '5px', color: 'dimgray' }}></i>{item.name}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </Tab.Panel>
                  ))}
                </Tab.Panels>
              </Tab.Group>

              <div className="border-t border-gray-200 py-6 px-4 space-y-6">
                {navigation.pages.map((page) => (
                  <div key={page.name} className="flow-root">
                    <a href={page.href} className="m-2 p-2 block font-medium text-gray-100 dark:text-gray-200">
                      {page.name}
                    </a>
                  </div>
                ))}
              </div>

              <div className="border-t border-gray-200 py-6 px-4 space-y-6">
                <div className="flow-root">
                <button
                      onClick={() => setTheme(colorTheme)}
                      className="p-3 bg-yellow-700  rounded-full text-white shadow"
                    >
                      {colorTheme === 'dark' ? (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" /></svg>



                      ) : (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" /></svg>

                      )}
                    </button>
                </div>
              </div>

              <div className="border-t border-gray-200 py-6 px-4">
           
                    <Listbox value={selected} onChange={setSelected}>
                    
                      <div className="mt-1 relative">
                        <Listbox.Button className="relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-yellow-700 focus:border-yellow-700 sm:text-sm">
                          <span className="flex items-center">
                            <img alt="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"title="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome" src={selected.flag}  className="flex-shrink-0 h-6 w-6 rounded-full" />
                            <span className="ml-3 block truncate">{selected.name}</span>
                          </span>
                          <span className="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                            <SelectorIcon className="h-5 w-5 text-gray-200" aria-hidden="true" />
                          </span>
                        </Listbox.Button>

                        <Transition as={Fragment} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
                          <Listbox.Options className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm list-none">
                          <p className="mt-1 font-medium text-gray-100">{t('language')}</p>
                            {language.map((item) => (
                              <Listbox.Option
                                key={item.code}
                                className={({ active }) =>
                                  classNames(
                                    active ? 'text-white bg-yellow-600 ' : 'text-gray-200 dark:text-gray-100',
                                    'cursor-default select-none relative py-2 pl-3 pr-9'
                                  )
                                }
                                value={item}
                                
                              >
                                {({ selected, active }) => (
                                  <>
                                    <div className="flex items-center">
                                    
                                      <img alt="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"title="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome" src={item.flag}  className="flex-shrink-0 h-6 w-6 rounded-full" />
                                      <button 
                                      onClick={() => window.location.replace("https://se.resania.com")}
                                      disabled= {item.code === currentLanguageCode}
                                      >
                                      <span className={classNames(selected ? 'font-semibold dark:text-gray-50' : 'font-normal dark:text-gray-200', 'ml-3 block truncate')}>
                                        {item.name}
                                      </span>
                                      </button>
                                    </div>

                                    {selected ? (
                                      <span
                                        className={classNames(
                                          active ? 'text-white dark:text-gray-50' : 'text-yellow-600',
                                          'absolute inset-y-0 right-0 flex items-center pr-4'
                                        )}
                                      >
                                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                      </span>
                                    ) : null}
                                  </>
                                )}
                              </Listbox.Option>
                            ))}
                          </Listbox.Options>
                        </Transition>
                      </div>
                    </Listbox>
              </div>
            </div>
          </Transition.Child>
        </Dialog>
      </Transition.Root>

      <header className="sticky top-0 ">
        <div className=' dark:bg-gray-darkest bg-gray-800 '>
          <nav aria-label="Top" className="max-w-8xl mx-auto px-8 sm:px-6 lg:px-28  dark:bg-gray-darkest ">
            <div className="border-b border-gray-900">
              <div className="flex items-center h-16">
                <button
                  type="button"
                  className="dark:bg-yellow-700  p-2 rounded-md text-gray-200 dark:text-gray-100 lg:hidden"
                  onClick={() => setOpen(true)}
                >
                  <span className="sr-only">Open menu</span>
                  <MenuIcon className="h-6 w-6" aria-hidden="true" />
                </button>
                <div className="ml-4 flex lg:ml-0">
                  {colorTheme === 'dark' ? (

                    <a href="/">
                      <img alt="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"title="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"
                        className="h-20 w-auto"
                        src="https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/ResaniaLogos/resanial%20logo%20PNG-10.png?color=yellow&shade=600"
                        
                      />
                    </a>
                  ) : (
                    <a href="/">
                      <img alt="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"title="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"
                        className="h-20 w-auto"
                        src="https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/ResaniaLogos/resanial%20logo%20PNG-10.png?color=yellow&shade=600"
                        
                      />
                    </a>
                  )}
                </div>

                {/* Flyout menus */}
                <Popover.Group className="hidden lg:ml-8 lg:block lg:self-stretch">
                  <div className="h-full flex space-x-6">
                    {navigation.categories.map((category) => (
                      <Popover key={category.name} className="flex">
                        {({ open }) => (
                          <>
                            <div className="relative flex ">
                              <Popover.Button
                                className={classNames(
                                  open
                                    ? 'border-green-600 text-blue-light'
                                    : 'border-transparent dark:text-gray-200 text-gray-100 hover:text-color',
                                  'relative z-10 flex items-center transition-colors ease-out duration-200 text-sm font-medium border-b-2 -mb-px pt-px'
                                )}
                              >
                            
                                {category.name}
                             
                              </Popover.Button>
                            </div>

                            <Transition
                              as={Fragment}
                              enter="transition ease-out duration-200"
                              enterFrom="opacity-0"
                              enterTo="opacity-100"
                              leave="transition ease-in duration-150"
                              leaveFrom="opacity-100"
                              leaveTo="opacity-0"
                            >
                              <Popover.Panel className="absolute top-full inset-x-0 text-sm text-gray-100 bg-gray-700">
                                <div className="absolute inset-0 top-1/2 bg-gray-700 dark:bg-gray-darkest shadow " aria-hidden="true" />

                                <div className="relative bg-gray-darkest">
                                  <div className="max-w-7xl mx-auto px-8">
                                    <div className="grid grid-cols-2 gap-y-10 gap-x-8 py-16">
                                      <div className="col-start-2 grid grid-cols-1 gap-x-3">
                                        <Carousel cols={3} rows={1} gap={10}>
                                          {category.featured.slice(0, 8).map((item, index) => (
                                            <Carousel.Item key={index}>
                                              <div key={item.title} className="group relative text-base sm:text-md">
                                                
                                                  <div className="aspect-w-1 aspect-h-1 rounded-lg bg-gray-700 overflow-hidden group-hover:opacity-75">
                                                    <img alt="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"title="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"
                                                      src={item.img_url}
                                                      
                                                      className="object-center object-cover"
                                                    />
                                                  </div>
                                                
                                                <a href={`/resania/${category.id}/${item.slug}`} className="mt-6 block font-medium text-gray-200 dark:text-gray-lightest">
                                                  <span className="absolute z-10 inset-0" aria-hidden="true" />
                                                  <h3 className="mt-4 text-sm text-gray-200">{item.tour_days}</h3>
                                                  <h3 className="mt-4 text-sm text-gray-200">{item.title}</h3>
                                                </a>
                                                {item.price ? (
                                                  <p className="mt-1 text-lg font-medium text-gray-200">From ${item.price}</p>
                                                ) : ''
                                                }

                                              </div>
                                            </Carousel.Item>
                                          ))}
                                        </Carousel>
                                      </div>
                                      <div className="row-start-1 grid grid-cols-2 gap-y-10 gap-x-8 text-sm ">
                                        {category.sections.map((section) => (
                                          <div key={section.name}>
                                            <p id={`${section.name}-heading`} className="mt-1 text-lg font-medium text-gray-200">
                                              {section.name}
                                            </p>
                                            <ul
                                              aria-labelledby={`${section.name}-heading`}
                                              className="mt-6 space-y-6 sm:mt-4 sm:space-y-4"
                                            >
                                              {section.items.map((item) => (
                                                <li key={item.name} className="flex">
                                                  <a href={item.href} className="dark:text-white hover:text-color text-gray-200  capitalize">
                                                    <i className={item.icon} aria-hidden="true" style={{ marginRight: '5px', color: 'dimgray' }}></i>{item.name}
                                                  </a>
                                                </li>
                                              ))}
                                            </ul>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Popover.Panel>
                            </Transition>
                          </>
                        )}
                      </Popover>
                    ))}

                    {navigation.pages.map((page) => (
                      <a
                        key={page.name}
                        href={page.href}
                        className="a-nav text-gray-100 hover:text-gray-300"
                      >
                        {page.name}
                      </a>
                    ))}
                  </div>
                </Popover.Group>

                <div className="ml-auto flex items-center">
                  <div className="hidden lg:ml-8 lg:flex">
                    <Listbox value={selected} onChange={setSelected}>
                    
                      <div className="mt-1 relative">
                        <Listbox.Button className="relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-yellow-700 focus:border-yellow-700 sm:text-sm">
                          <span className="flex items-center">
                            <img alt="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"title="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome" src={selected.flag}  className="flex-shrink-0 h-6 w-6 rounded-full" />
                            <span className="ml-3 block truncate text-gray-300">{selected.name}</span>
                          </span>
                          <span className="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                            <SelectorIcon className="h-5 w-5 text-gray-200" aria-hidden="true" />
                          </span>
                        </Listbox.Button>

                        <Transition as={Fragment} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
                          <Listbox.Options className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm list-none">
                          <p className="mt-1 font-medium text-gray-200">{t('language')}</p>
                            {language.map((item) => (
                              <Listbox.Option
                                key={item.code}
                                className={({ active }) =>
                                  classNames(
                                    active ? 'text-white bg-yellow-600 ' : 'text-gray-100 dark:text-gray-100',
                                    'cursor-default select-none relative py-2 pl-3 pr-9'
                                  )
                                }
                                value={item}
                                
                              >
                                {({ selected, active }) => (
                                  <>
                                    <div className="flex items-center">
                                    
                                      <img alt="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"title="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome" src={item.flag}  className="flex-shrink-0 h-6 w-6 rounded-full" />
                                      <a
                                    href={`https://${item.code}resania.com`}
                                    className="inline-flex items-center justify-center"
                                  >
                                      <button
                                        
                                        disabled={
                                          item.code === currentLanguageCode
                                        }
                                      >
                                        <span
                                          className={classNames(
                                            selected
                                              ? "font-semibold dark:text-gray-500"
                                              : "font-normal dark:text-gray-100",
                                            "ml-3 block truncate"
                                          )}
                                        >
                                          {item.name}
                                        </span>
                                      </button>

                                  </a>

                                    </div>

                                    {selected ? (
                                      <span
                                        className={classNames(
                                          active ? 'text-white dark:text-gray-100' : 'text-yellow-600',
                                          'absolute inset-y-0 right-0 flex items-center pr-4'
                                        )}
                                      >
                                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                      </span>
                                    ) : null}
                                  </>
                                )}
                              </Listbox.Option>
                            ))}
                          </Listbox.Options>
                        </Transition>
                      </div>
                    </Listbox>
                  </div>

                  {/* Search */}
                  <div className="flex lg:ml-6">
                  <button
                      onClick={() => setTheme(colorTheme)}
                      className="p-3 bg-yellow-700  rounded-full text-white shadow"
                    >
                      {colorTheme === 'dark' ? (
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" /></svg>



                      ) : (
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" /></svg>

                      )}
                    </button>
                  </div>

                  {/* Cart */}
                </div>
              </div>
            </div>
          </nav>
        </div>
      </header>
    </div>

  )
}
